import React from 'react'

const HEADERS = ['SERIE', 'NUMAR', 'PRODUS', 'PRET', 'DATA', '']
const API_URL = process.env.REACT_APP_API_URL

const InvoicesTable = ({ payments }) => {
  return (
    <div className="flex flex-col">
      <span className="text-gray-500 font-bold">Facturile tale</span>
      <hr className="w-[60%] bg-over-ternary-background mt-1" />
      <div className="mt-8 flex gap-3 w-full text-over-primary-background text-lg font-bold">
        {payments.length === 0 ? (
          <span>Nu ai făcut nicio plată până acum.</span>
        ) : (
          <div className="overflow-x-auto w-full">
            <table className="min-w-full   border-gray-200 shadow-md text-sm w-full">
              <thead>
                <tr className="text-left text-gray-500 font-bold">
                  {HEADERS.map(header => {
                    return (
                      <th
                        key={`header-${header}`}
                        className="border-b border-gray-200 px-4 py-2"
                      >
                        {header}
                      </th>
                    )
                  })}
                </tr>
              </thead>
              <tbody>
                {payments.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="border-b border-gray-200 px-4 py-2">
                      {item.serie}
                    </td>
                    <td className="border-b border-gray-200 px-4 py-2">
                      {item.numar}
                    </td>
                    <td className="border-b border-gray-200 px-4 py-2">
                      {item.nume_produs}
                    </td>
                    <td className="border-b border-gray-200 px-4 py-2">
                      {item.pret_unitar}
                    </td>
                    <td className="border-b border-gray-200 px-4 py-2">
                      {new Date(item.timestamp * 1000).toLocaleDateString()}
                    </td>
                    <td className="border-b border-gray-200 px-4 py-2 ">
                      <a
                        className="text-white bg-btn-primary px-4 py-1 max- rounded "
                        href={`${API_URL}payment/get_factura?download_token=${item.download_token}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span>Descarcă</span>
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  )
}

export default InvoicesTable
